class SubmitPayNowService {
  constructor(rest) {
    this.rest = rest;
  }

  request() {
    return this.rest({
      method: 'POST',
      path: '/api/account/collectPayment'
    });
  }
}

export default SubmitPayNowService;



/** WEBPACK FOOTER **
 ** ./src/services/SubmitPayNowService.js
 **/